export { default } from './SectionRelatedTerms';